import React from 'react';
import { useStoreState } from 'base/store';

type WhatsAppLinkProps = {
    className?: string;
    value: string;
};

const WhatsAppLink: React.FC<WhatsAppLinkProps> = props => {
    const { className, value } = props;
    const { ua: { isPhone } } = useStoreState('rootStore');

    return isPhone
        ? <a className={className} href={`whatsapp://send?phone=${value}`}>{value}</a>
        : <span className={className}>{value}</span>
};

export default WhatsAppLink;